export default (store) => {
  return async (to, from, next) => {
    if (store.state.value.user?.profile) {
      return next({ path: "/redirection" });
    }
    return next();
  };
};
